import styled from 'styled-components';

import { spacing, colors, transitions } from '../../../styles/theme';

import BaseLogo from '../Logo';

export const Container = styled.div`
  width: 70%;
  margin: auto;
`;

export const Form = styled.form`
  margin-top: 16px;
  width: 100%;

  button {
    margin: ${spacing('4')} 0 ${spacing('2')} 0;
  }
`;

export const Logo = styled(BaseLogo)`
  margin: 0 auto ${spacing('3')} auto;
`;

export const TitleContainer = styled.div`
  margin-bottom: ${spacing('4')};

  p + p {
    margin-top: ${spacing('1')};
  }
`;

export const ActionButton = styled.a`
  font-weight: 600;
  color: ${colors('primary.base')};
  text-decoration: none;
  cursor: pointer;
  transition: filter ${transitions('fast')};
  text-underline-offset: 3px;

  &:hover {
    transition: filter ${transitions('fast')};
    filter: ${transitions('effect.brightnessHigh')};
    text-decoration: underline;
  }
`;
